module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', [(_vm.currentBbr === _vm.bbr.id) ? _c('rect', {
    staticStyle: {
      "fill": "lightgrey",
      "stroke-width": "2",
      "stroke": "grey"
    },
    attrs: {
      "x": _vm.xStart,
      "y": _vm.y,
      "rx": "4",
      "width": "200",
      "height": "44"
    }
  }) : _c('rect', {
    staticStyle: {
      "fill": "white",
      "stroke-width": "2",
      "stroke": "grey"
    },
    attrs: {
      "x": _vm.xStart,
      "y": _vm.y,
      "rx": "4",
      "width": "200",
      "height": "44"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "text-anchor": "middle"
    }
  }, [_c('tspan', {
    staticClass: "subtitle-2",
    attrs: {
      "x": _vm.xStart + 100,
      "y": _vm.y + 20
    }
  }, [(_vm.bbr.titel) ? _c('span', {
    staticClass: "pr-1"
  }, [_vm._v(_vm._s(_vm.bbr.titel))]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.bbr.nachname) + ", " + _vm._s(_vm.bbr.vorname) + "\n    ")]), _vm._v(" "), _c('tspan', {
    staticClass: "caption",
    attrs: {
      "x": _vm.xStart + 100,
      "y": _vm.y + 36
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$filters.date(_vm.bbr.receptionsdatum, "DD.MM.YYYY")) + "\n    ")])]), _vm._v(" "), (_vm.ebene > 0) ? _c('path', {
    attrs: {
      "d": 'M' +
        (_vm.xVater + 100) +
        ' ' +
        (_vm.yVater + 44) +
        ' C ' +
        (_vm.xVater + 100) +
        ' ' +
        (_vm.yVater + 65) +
        ' ' +
        (_vm.xStart + 100) +
        ' ' +
        (_vm.yVater + 45) +
        ' ' +
        (_vm.xStart + 100) +
        ' ' +
        (_vm.yVater + 65) +
        'L' +
        (_vm.xStart + 100) +
        ' ' +
        _vm.y,
      "stroke": "grey",
      "stroke-width": "2",
      "fill": "none"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.sohn), function(node, index) {
    return _c('stammbaumKnoten', {
      key: index,
      staticClass: "mt-n2",
      attrs: {
        "sohn": node.sohn,
        "bbr": node.bbr,
        "getArrayDepth": node.getArrayDepth,
        "blatter": node.blatter,
        "ebene": _vm.ebene + 1,
        "currentBbr": _vm.currentBbr,
        "dense": _vm.dense,
        "kachelbreite": _vm.kachelbreite,
        "startJahr": _vm.startJahr,
        "xStart": _vm.calculateXStart(index, node),
        "xMin": _vm.calculateXMin(index, node),
        "xWidth": (_vm.xWidth / _vm.blatter) * node.blatter,
        "xVater": _vm.xStart,
        "yVater": _vm.y,
        "collapse": _vm.collapse
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8efdc45a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/stammbaumKnotenNeu.vue
// module id = 801
// module chunks = 15